import React from 'react';
interface CalculatorSliderProps {
  label: string;
  value: number;
  min: number;
  max: number;
  onChange: (value: number) => void;
}
export function CalculatorSlider({
  label,
  value,
  min,
  max,
  onChange
}: CalculatorSliderProps) {
  return <div data-id="element-1" data-mp="2bkdfu1b0xoes">
      <div className="mb-2 flex items-center justify-between gap-4" data-id="element-2" data-mp="2bkmx90i06n8v">
        <label className="text-sm font-semibold text-[var(--fg)]" data-id="element-3" data-mp="2ggu54ytym8tg">{label}</label>
        <input type="number" value={value} min={min} max={max} onChange={event => {
        const nextValue = Number(event.target.value);
        if (!Number.isNaN(nextValue)) {
          onChange(Math.max(min, Math.min(max, nextValue)));
        }
      }} className="w-20 rounded-lg border border-[var(--brand)]/15 bg-white px-2 py-1.5 text-right text-sm font-bold text-[var(--fg)] outline-none transition focus:border-[var(--brand)] focus:ring-2 focus:ring-[var(--brand)]/15" aria-label={`${label} value`} data-id="element-4" data-mp="1iuodnkmkvibl" />
      </div>
      <input type="range" value={value} min={min} max={max} onChange={event => onChange(Number(event.target.value))} className="deck-slider w-full" aria-label={label} data-id="element-5" data-mp="2icgp8czu2j7f" />
      <div className="mt-1.5 flex justify-between text-[10px] font-semibold text-[var(--muted)]" data-id="element-6" data-mp="24d7j665cd5h6">
        <span data-id="element-7" data-mp="1ze4b0cu2ej4z">{min}</span>
        <span data-id="element-8" data-mp="1zenrdp42gzgw">{max}</span>
      </div>
    </div>;
}